import React from 'react';
import { useContext, useMemo } from 'react';
import { Button } from '@mui/material';
import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const GeneralButton = (props) => {
	const { getAccessControlSet } = useContext(UserContext);
	const system = props.system || SYSTEMS.FRAMERATE;
	/**
	 * This variable contains a set of strings that signifies if this button is either visible/disabled/hidden
	 * @type {Set<string>}
	 */
	const generalButtonControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.BUTTON_NAMES, props.name);
	}, [getAccessControlSet, props.name, system]);

	const shouldDisable = !!props?.disable;

	return (
		<>
			{!generalButtonControlledAccessSet.has(UI_ACCESS.HIDE) && (
				<Button disabled={generalButtonControlledAccessSet.has(UI_ACCESS.DISABLE) || shouldDisable} {...props}>
					{props.children}
				</Button>
			)}
		</>
	);
};

export default GeneralButton;
